/**
 * Clarification Sheet derivation — port of WEB-CRM-Frontend features/LLM/clarificationSheet.ts
 */

export const SHEET_CHAIN_WINDOW_MS = 9 * 60 * 1000;

export function isSheetPageBlock(block) {
  return (
    block?.type === 'entity_choice' &&
    typeof block.sheet_id === 'string' &&
    typeof block.field === 'string' &&
    typeof block.field_label === 'string' &&
    !!block.options?.length
  );
}

export function deriveSheetFromParts(parts) {
  if (!parts) return null;

  const pagesBySheet = new Map();
  for (const part of parts) {
    if (part.kind !== 'block' || !isSheetPageBlock(part.block)) continue;
    const block = part.block;
    const pages = pagesBySheet.get(block.sheet_id) ?? [];
    pages.push({
      field: block.field,
      fieldLabel: block.field_label,
      question: block.prompt,
      options: block.options ?? [],
    });
    pagesBySheet.set(block.sheet_id, pages);
  }

  const first = pagesBySheet.entries().next();
  if (first.done) return null;
  const [sheetId, pages] = first.value;
  return { sheetId, pages };
}

function isWithinChainWindow(at, now) {
  const stamped = Date.parse(at ?? '');
  return Number.isNaN(stamped) || now - stamped <= SHEET_CHAIN_WINDOW_MS;
}

export function deriveClarificationSheet(messages, now = Date.now()) {
  const last = messages?.[messages.length - 1];
  if (!last || last.role !== 'assistant') return null;
  if (!isWithinChainWindow(last.createdAt, now)) return null;
  return deriveSheetFromParts(last.parts);
}

export function buildSheetAnswerMessage(answers) {
  return answers.map((a) => `${a.fieldLabel}: ${a.value}`).join(', ');
}
